<template>
  <div>
    <HistoryInfoBoxes :detail="info">
      <template #box0>
        <v-row no-gutters>
          <v-col cols="3"
            >{{ $t('refund.refund_target-order-number') }}：
          </v-col>
          <v-col>{{ items.sale.transaction.controlNumber }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3">{{ $t('ship.ship_ship-history') }}： </v-col>
          <v-col>{{ items.transaction.controlNumber }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3">{{ $t('ship.ship_tracking-number') }}： </v-col>
          <v-col>{{ items.trackingNumber }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3">{{ $t('common.input_remarks') }}： </v-col>
          <v-col>{{ items.shipNote ? items.shipNote.body : '' }} </v-col>
        </v-row>
      </template>
      <template #box1>
        <v-row no-gutters>
          <v-col class="mb-1 font-weight-bold nameText">
            {{ getName(items.destName, items.destOrganizationName) }}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col
            >{{
              getCountryName(items.destCountryId) +
              ' ' +
              getPostalCode(items.destPostalCode, items.destCountryId)
            }}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>{{ getAddress(items) }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="2">{{ $t('common.input_phone-number') }}： </v-col>
          <v-col
            >{{
              getPhoneNumber(
                items.destPhoneNumber,
                items.destPhoneNumberCountryCode
              )
            }}
          </v-col>
        </v-row>
      </template>
    </HistoryInfoBoxes>
  </div>
</template>
<script>
import HistoryInfoBoxes from '@/components/items/Designs/HistoryInfoBoxes'
import { commonUtil, countryUtil, countryCallingCodeUtil } from '@/util'

export default {
  components: { HistoryInfoBoxes },
  props: {
    items: { default: {} }
  },
  data: () => ({
    info: []
  }),
  created() {
    this.info = this.createList()
  },
  methods: {
    createList() {
      const shipInfo = {
        ...this.interfaceObj,
        title: 'ship.ship_ship-info'
      }
      const destinationInfo = {
        ...this.interfaceObj,
        title: 'ship.ship_ship-dest-info'
      }

      return [shipInfo, destinationInfo]
    },
    getName(name, organizationName) {
      const combinedName = commonUtil.getSeparateWordsBySpace([
        organizationName,
        name
      ])
      return combinedName ? combinedName + this.$t('sale.sale_mr') : ''
    },
    getCountryName(id) {
      const country = countryUtil.findCountryId(id)
      return country ? country.name : ''
    },
    getRegionName(countryId, regionId) {
      return countryUtil.getRegionInfo(countryId, regionId).label
    },
    getPhoneNumber(phone, callingCode) {
      return countryCallingCodeUtil.formatPhoneNumber(phone, callingCode)
    },
    getPostalCode(postalCode, countryId) {
      if (!postalCode) return ''
      return commonUtil.formatPostalCode(postalCode, countryId)
    },
    getAddress(item) {
      let address = ''
      if (item.destAddress1) address += item.destAddress1
      if (item.destAddress2) address += item.destAddress2
      return this.getRegionName(item.destCountryId, item.destRegionId) + address
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
.nameText {
  font-size: 14px;
}
</style>
